import React from 'react';

// Create a context for the block element
export const BlockElementContext = React.createContext<string | null>(null);

// Hook to access the block element
export function useBlockElementId() {
  const context = React.useContext(BlockElementContext);
  if (!context) {
    throw new Error(
      'useBlockElement must be used within BlockElementContext.Provider'
    );
  }
  return context;
}
